import { Button, Grid, Modal } from '@mui/material';
import { Box } from '@mui/system';
import { useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
const CloseConfirmationLock = ({ parentModalClose }) => {
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        boxShadow: 24
    };
    const [open, setOpen] = useState(true);
    const handleClose = (type) => {
        setOpen(false);
        parentModalClose(type);
    };
    return (
        <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
            <Box sx={style} className="modal-box">
                <PerfectScrollbar
                    style={{ maxHeight: 'calc(100vh - 100px)', padding: '0 12px' }}
                    options={{ suppressScrollX: true, useBothWheelAxes: false }}
                >
                    <>
                        <Box className="modal-header">
                            <h3>You seem inactive. Do you want to continue editing?</h3>
                        </Box>
                        <Grid item xs={12}>
                            <Box className="modal-footer-2">
                                <Button className="alternate-reversed" onClick={() => handleClose('Y')}>
                                    Yes
                                </Button>
                                <Button type="submit" className="alternate" onClick={() => handleClose('N')}>
                                    No
                                </Button>
                            </Box>
                        </Grid>
                    </>
                </PerfectScrollbar>
            </Box>
        </Modal>
    );
};

export default CloseConfirmationLock;
